// /* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect, useRef, useState } from "react";
// import NormalSearch from "../../../components/common/NormalSearch";

// type Props = {
//   ALL_CITIES: any[];
//   selectedCityData: any[];
//   setSelectedCitiesArray?: (data: any[]) => void;
//   coverageType?: string;
//   coverageCity?: string;
//   coverageCountry?: string;
//   error?: string;
//   setError?: (data: string) => void;
//   isEdit: boolean;
// };

// const CoverageCities = ({
//   setSelectedCitiesArray,
//   error,
//   setError,
//   isEdit,
//   coverageType,
//   coverageCountry,
//   coverageCity,
//   selectedCityData = [],
//   ALL_CITIES = [],
// }: Props) => {
//   const [selectedCities, setSelectedCities] =
//     useState<string[]>(selectedCityData);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredCities, setFilteredCities] = useState<any[]>([]);
//   const [visibleCities, setVisibleCities] = useState<any[]>([]);
//   const [cityPage, setCityPage] = useState(1);
//   const listRef = useRef<HTMLDivElement | null>(null);

//   const CITIES_PER_PAGE = 50;

//   // 🔹 Filter cities based on search
//   useEffect(() => {
//     setFilteredCities(
//       ALL_CITIES.filter((city) =>
//         city?.name?.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//     );
//   }, [ALL_CITIES, searchQuery, coverageType]);

//   // 🔹 Reset selected cities when coverage changes
//   useEffect(() => {
//     setSelectedCities([]);
//   }, [coverageType, coverageCountry, coverageCity]);

//   // 🔹 Pass selected cities upward
//   useEffect(() => {
//     if (setSelectedCitiesArray) setSelectedCitiesArray(selectedCities);
//     if (selectedCities.length > 0 && setError) setError("");
//   }, [selectedCities]);

//   // 🔹 Initialize from selectedCityData
//   useEffect(() => {
//     if (selectedCityData?.length > 0) {
//       setSelectedCities(selectedCityData);
//     }
//   }, [selectedCityData]);

//   // 🔹 Update visible cities (pagination)
//   useEffect(() => {
//     if (filteredCities.length) {
//       const newCities = filteredCities.slice(0, cityPage * CITIES_PER_PAGE);
//       setVisibleCities(newCities);
//     } else {
//       setVisibleCities([]);
//     }
//   }, [filteredCities, cityPage]);

//   const handleScroll = () => {
//     const container = listRef.current;
//     if (
//       container &&
//       container.scrollTop + container.clientHeight >=
//         container.scrollHeight - 10
//     ) {
//       if (cityPage * CITIES_PER_PAGE < filteredCities.length) {
//         setCityPage((prev) => prev + 1);
//       }
//     }
//   };

//   // 🔹 Select / Deselect logic
//   const toggleCity = (cityId: string) => {
//     setSelectedCities((prev) =>
//       prev.includes(cityId)
//         ? prev.filter((id) => id !== cityId)
//         : [...prev, cityId]
//     );
//   };

//   const selectAll = () => {
//     setSelectedCities(ALL_CITIES.map((city) => city.id));
//   };

//   const deselectAll = () => {
//     setSelectedCities([]);
//   };

//   const allSelected =
//     selectedCities.length === ALL_CITIES.length && ALL_CITIES.length > 0;
//   const noneSelected = selectedCities.length === 0;

//   return (
//     <div className="space-y-4">
//       {/* 🔍 Search */}
//       <div className="flex items-center gap-2 w-full">
//         <NormalSearch
//           className="w-full"
//           value={searchQuery}
//           onChange={(e: any) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       <div className="grid grid-cols-2 gap-4">
//         {/* ---------------- LEFT COLUMN ---------------- */}
//         <div className="border border-[#d2d2d2] rounded-lg">
//           <div className="flex items-center border-b border-[#d2d2d2] justify-between p-2">
//             <h3 className="text-[#1E293B]">
//               {coverageType?.[0]?.toUpperCase()}
//               {coverageType?.slice(1)} List{" "}
//               {visibleCities?.length - (selectedCities?.length || 0) > 0 &&
//                 `(${visibleCities?.length - (selectedCities?.length || 0)})`}
//             </h3>

//             {/* ✅ Select All */}
//             <button
//               onClick={selectAll}
//               disabled={allSelected}
//               className={`text-[#1E1E1E]/70 text-sm flex items-center space-x-1 ${
//                 allSelected ? "opacity-50 cursor-not-allowed" : ""
//               }`}
//             >
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={allSelected}
//                   readOnly
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                              bg-white checked:bg-[#FBD037] checked:text-white"
//                 />
//                 <span
//                   className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                              top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                 >
//                   ✓
//                 </span>
//               </label>
//               <span>Select All</span>
//             </button>
//           </div>

//           <div className="space-y-2 max-h-96 overflow-y-auto p-2">
//             <div
//               className="  overflow-auto space-y-2"
//               onScroll={handleScroll}
//               ref={listRef}
//             >
//               {visibleCities.map(
//                 (city) =>
//                   !selectedCities.includes(city.id) && (
//                     <div key={city.id} className="flex items-center gap-2">
//                       <label className="relative flex items-center cursor-pointer">
//                         <input
//                           type="checkbox"
//                           checked={selectedCities.includes(city.id)}
//                           onChange={() => toggleCity(city.id)}
//                           disabled={false}
//                           className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                      bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                         />
//                         <span
//                           className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                      top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                         >
//                           ✓
//                         </span>
//                       </label>
//                       <p className="text-sm">{city.name}</p>
//                     </div>
//                   )
//               )}
//             </div>

//             {error && (
//               <span className="text-red-500 text-sm block pl-3">{error}</span>
//             )}
//           </div>
//         </div>

//         {/* ---------------- RIGHT COLUMN ---------------- */}
//         <div className="border border-[#d2d2d2] rounded-lg">
//           <div className="border-b border-[#d2d2d2] p-2 flex justify-between items-center">
//             <h3 className="text-[#1E293B]">
//               Coverage {coverageType?.[0]?.toUpperCase()}
//               {coverageType?.slice(1)} List
//             </h3>

//             {/* ✅ Deselect All */}
//             <button
//               onClick={deselectAll}
//               disabled={noneSelected}
//               className={`text-[#1E1E1E]/70 text-sm flex items-center space-x-1 ${
//                 noneSelected ? "opacity-50 cursor-not-allowed" : ""
//               }`}
//             >
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={noneSelected}
//                   readOnly
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                              bg-white checked:bg-[#FBD037] checked:text-white"
//                 />
//                 <span
//                   className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                              top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                 >
//                   ✓
//                 </span>
//               </label>
//               <span>Deselect All</span>
//             </button>
//           </div>

//           <div className="space-y-2 max-h-96 overflow-y-auto p-2">
//             {selectedCities.map((cityId) => {
//               const city = ALL_CITIES.find((c) => c.id === cityId);
//               return (
//                 city && (
//                   <div key={cityId} className="flex items-center gap-2">
//                     <label className="relative flex items-center cursor-pointer">
//                       <input
//                         type="checkbox"
//                         checked
//                         onChange={() => toggleCity(cityId)}
//                         readOnly
//                         className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                    bg-white checked:bg-[#FBD037] checked:text-white"
//                       />
//                       <span
//                         className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                    top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                       >
//                         ✓
//                       </span>
//                     </label>
//                     <p className="text-sm">{city.name}</p>
//                   </div>
//                 )
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoverageCities;

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {
  ALL_CITIES: any[];
  selectedCityData: any[];
  setSelectedCitiesArray?: (data: any[]) => void;
  coverageType?: string;
  coverageCity?: string;
  coverageCountry?: string;
  error?: string;
  setError?: (data: string) => void;
  isEdit: boolean;
};

const CITIES_PER_PAGE = 50;

const CoverageCities = ({
  setSelectedCitiesArray,
  error,
  setError,
  isEdit,
  coverageType,
  coverageCountry,
  coverageCity,
  selectedCityData = [],
  ALL_CITIES = [],
}: Props) => {
  const [selectedCities, setSelectedCities] = useState<any[]>(selectedCityData);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState<any[]>([]);
  const [visibleCities, setVisibleCities] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const { t, language } = useLanguage();

  const getCityName = (city: any) => {
    if (language === "ar") {
      const aliasAr = Array.isArray(city?.aliasArabic)
        ? city.aliasArabic[0]
        : city?.aliasArabic;
      if (aliasAr) return aliasAr;
    }
    return city?.name || "";
  };

  /* ---------------- FILTER + RESET PAGE ---------------- */
  useEffect(() => {
    const filtered = ALL_CITIES.filter((city) => {
      const engName = city?.name?.toLowerCase() || "";
      const arAlias = (Array.isArray(city?.aliasArabic) ? city.aliasArabic[0] : city?.aliasArabic) || "";
      const query = searchQuery?.toLowerCase() || "";
      return engName.includes(query) || arAlias.toLowerCase().includes(query);
    });

    setFilteredCities(filtered);
    setPage(1); // 🔥 reset to 50
  }, [ALL_CITIES, searchQuery, coverageType]);

  /* ---------------- PAGINATION ---------------- */
  useEffect(() => {
    setVisibleCities(filteredCities.slice(0, page * CITIES_PER_PAGE));
  }, [filteredCities, page]);

  /* ---------------- RESET ON COVERAGE CHANGE ---------------- */
  useEffect(() => {
    setSelectedCities([]);
  }, [coverageType, coverageCountry, coverageCity]);

  /* ---------------- INIT EDIT DATA ---------------- */
  useEffect(() => {
    if (selectedCityData?.length) {
      setSelectedCities(selectedCityData);
    }
  }, [selectedCityData]);

  /* ---------------- PASS UP ---------------- */
  useEffect(() => {
    setSelectedCitiesArray?.(selectedCities);
    if (selectedCities.length && setError) setError("");
  }, [selectedCities]);

  /* ---------------- SCROLL HANDLER ---------------- */
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const el = e.currentTarget;

    if (
      el.scrollTop + el.clientHeight >= el.scrollHeight - 5 &&
      visibleCities.length < filteredCities.length
    ) {
      setPage((prev) => prev + 1);
    }
  };

  /* ---------------- TOGGLE ---------------- */
  const toggleCity = (cityId: string) => {
    setSelectedCities((prev) =>
      prev.includes(cityId)
        ? prev.filter((id) => id !== cityId)
        : [...prev, cityId]
    );
  };

  const selectAll = () => {
    setSelectedCities(ALL_CITIES.map((city) => city.id));
  };

  const deselectAll = () => setSelectedCities([]);

  const allSelected =
    selectedCities.length === ALL_CITIES.length && ALL_CITIES.length > 0;
  const noneSelected = selectedCities.length === 0;

  // search for right side
  const filteredSelectedCities = selectedCities
    .map((id) => ALL_CITIES.find((c) => c.id === id))
    .filter((city) => {
      if (!city) return false;
      const engName = city?.name?.toLowerCase() || "";
      const arAlias = (Array.isArray(city?.aliasArabic) ? city.aliasArabic[0] : city?.aliasArabic) || "";
      const query = searchQuery?.toLowerCase() || "";
      return engName.includes(query) || arAlias.toLowerCase().includes(query);
    });

  return (
    <div className="space-y-4">
      {/* 🔍 Search */}
      <div className="flex items-center gap-2 w-full">
        <NormalSearch
          className="w-full"
          value={searchQuery}
          onChange={(e: any) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* ---------------- LEFT COLUMN ---------------- */}
        <div className="border border-[#d2d2d2] rounded-lg">
          <div className="flex items-center border-b border-[#d2d2d2] justify-between p-2">
            <h3 className="text-[#1E293B]">
              {coverageType
                ? t(`${coverageType.charAt(0).toUpperCase() + coverageType.slice(1)} List`)
                : t("Cities List")}{" "}
              {filteredCities.length - selectedCities.length > 0 &&
                `(${filteredCities.length - selectedCities.length})`}
            </h3>

            {/* Select All */}
            <button
              onClick={selectAll}
              disabled={allSelected}
              className={`text-[#1E1E1E]/70 text-sm flex items-center space-x-1 ${
                allSelected ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={allSelected}
                  readOnly
                  className="peer h-5 w-5 appearance-none rounded border border-slate-300 checked:border-[#FBD037]
                             bg-white checked:bg-[#FBD037]"
                />
                <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 top-1/2 left-[10px] -translate-x-1/2 -translate-y-1/2">
                  ✓
                </span>
              </label>
              <span>{t("Select All")}</span>
            </button>
          </div>

          {/* 🔥 SINGLE SCROLL CONTAINER (UI SAME) */}
          <div
            className="space-y-2 max-h-96 overflow-y-auto p-2 overscroll-contain"
            onScroll={handleScroll}
          >
            {visibleCities.map(
              (city) =>
                !selectedCities.includes(city.id) && (
                  <div key={city.id} className="flex items-center gap-2">
                    <label className="relative flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={selectedCities.includes(city.id)}
                        onChange={() => toggleCity(city.id)}
                        className="peer h-5 w-5 appearance-none rounded border border-slate-300 checked:border-[#FBD037]
                                   bg-white checked:bg-[#FBD037]"
                      />
                      <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 top-1/2 left-[10px] -translate-x-1/2 -translate-y-1/2">
                        ✓
                      </span>
                    </label>
                    <p className="text-sm">{getCityName(city)}</p>
                  </div>
                )
            )}
          </div>
          {error && (
            <span className="text-red-500 text-sm block pl-3">{error}</span>
          )}
        </div>

        {/* ---------------- RIGHT COLUMN ---------------- */}
        <div className="border border-[#d2d2d2] rounded-lg">
          <div className="border-b border-[#d2d2d2] p-2 flex justify-between items-center">
            <h3 className="text-[#1E293B]">
              {coverageType
                ? t(`Coverage ${coverageType.charAt(0).toUpperCase() + coverageType.slice(1)} List`)
                : t("Coverage Cities List")}
            </h3>
            <button
              onClick={deselectAll}
              disabled={noneSelected}
              className={`text-[#1E1E1E]/70 text-sm flex items-center space-x-1 ${
                noneSelected ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={noneSelected}
                  readOnly
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
                            bg-white checked:bg-[#FBD037] checked:text-white"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
                            top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
              <span>{t("Deselect All")}</span>
            </button>
          </div>

          <div className="space-y-2 max-h-96 overflow-y-auto p-2">
            {filteredSelectedCities.map((city) => (
              <div key={city.id} className="flex items-center gap-2">
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked
                    onChange={() => toggleCity(city.id)}
                    className="peer h-5 w-5 appearance-none rounded border border-slate-300
                   checked:border-[#FBD037] bg-white checked:bg-[#FBD037]"
                  />
                  <span
                    className="absolute text-xs font-bold text-white
                       peer-checked:opacity-100 opacity-0
                       top-1/2 left-[10px] -translate-x-1/2 -translate-y-1/2"
                  >
                    ✓
                  </span>
                </label>
                <p className="text-sm">{getCityName(city)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageCities;
